import { FC, SVGProps } from "react";

interface BrokenImageSVGProps extends SVGProps<SVGSVGElement> {
    iconColor?: string;
    strokeWidth?: number;
}

export const BrokenImageSVG: FC<BrokenImageSVGProps> = ({
    className = "w-[100px] h-[80px]",
    iconColor = "#9F9F9F",
    strokeWidth = 1.5,
    ...props
}) => {
    return (
        <svg
            className={className}
            viewBox="0 0 24 24"
            fill="none"
            stroke={iconColor}
            strokeWidth={strokeWidth}
            strokeLinecap="round"
            strokeLinejoin="round"
            {...props}
        >
            <path d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h7" />
            
            <line x1="12" y1="3" x2="21" y2="12" />
            
            <circle cx="9" cy="9" r="2" />
            
            <path d="M21 15l-3.086-3.086a2 2 0 0 0-2.828 0L6 21" />
        </svg>
    );
};

export default BrokenImageSVG;